import { styled } from '@mui/system'
import { keyframes } from '@mui/system'

// Define the fade-in-up animation
const fadeInUpKeyframes = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

interface ListAnimationProps {
  index: number
  stagger?: number
  duration?: number
  component?: React.ElementType
}

export const ListAnimation = styled('div')<ListAnimationProps>(
  ({ theme, index, stagger = 100, duration = 300 }) => ({
    opacity: 0,
    animation: `${fadeInUpKeyframes} ${duration}ms ease-out forwards`,
    animationDelay: `${index * stagger}ms`,
    animationFillMode: 'forwards',
    transition: 'all 0.3s ease-out',

    willChange: 'opacity, transform',

    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
      opacity: 1,
    },
  })
)
